import ImportExportDoiInventoryPolicyComponent from 'components/import-export-json/import-export-doi-inventory-policy';
import moment from 'moment';
import { Component } from 'react';
import intl from 'react-intl-universal';
import { downloadFile } from 'utils/custom-functions';
import * as services from './importer-exporter-doi-inventory-policy.service';

interface Props {
  handleClose: () => void
  open: boolean
}

class ImportExportDoiInventoryPolicy extends Component<Props> {
  downloadFile = async (): Promise<void> => {
    try {
      const data = await services.downloadDoiInventoryPolicy();
      const datafile = moment(new Date()).format('YYYYMMDD_HHmmss');
      downloadFile(`${intl.get('commons.doiInventoryPolicyFile')}_${datafile}.csv`, 'csv', data);
    } catch (e) {
      console.error('Error downloading file:', e);
    }
  };

  downloadTemplate = async (): Promise<void> => {
    try {
      const data = await services.downloadDoiInventoryPolicyTemplate();
      const datafile = moment(new Date()).format('YYYYMMDD_HHmmss');
      downloadFile(`${intl.get('commons.doiInventoryPolicyTemplate')}_${datafile}.csv`, 'csv', data);
    } catch (e) {
      console.error('Error downloading template:', e);
    }
  };

  render(): JSX.Element {
    const { open, handleClose } = this.props;

    return (
      <ImportExportDoiInventoryPolicyComponent
        open={open}
        title={intl.get('exportImportModal.doiInventoryPolicy.title')}
        contextModal="doiInventoryPolicy"
        handleClose={handleClose}
        downloadArquivo={this.downloadFile}
        downloadModelo={this.downloadTemplate}
      />
    );
  }
}

export default ImportExportDoiInventoryPolicy;
